import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PropertiesPage from './pages/PropertiesPage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import ProcessPage from './pages/ProcessPage';
import SharedPropertiesPage from './pages/SharedPropertiesPage';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

function App() {
  return (
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/nosotros" element={<AboutPage />} />
            <Route path="/proceso" element={<ProcessPage />} />
            <Route path="/contacto" element={<ContactPage />} />
            <Route path="/properties" element={<PropertiesPage />} />
            <Route path="/inmueble/:consecutivo" element={<PropertyDetailPage />} />
            <Route path="/inmuebles-compartidos/:idGenerado" element={<SharedPropertiesPage />} />
            {/* Ruta catch-all para páginas no encontradas - DEBE IR AL FINAL */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </Router>
  );
}

export default App;

